<template>
  <QuotationResourceForm
    @submit="submit"
    v-model="formResource"
    @cancel="cancelQuotationButton"
    :form="readonlyForm.resource"
    @return="previousStep"
    :emissionType="firstForm.emissionType"
    :submodalityType="firstForm.subModality"
  />
</template>
<script>
import QuotationResourceForm from "../components/QuotationResourceForm";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import _ from "lodash";
export default {
  name: "QuotationFirstStepResource",
  data: () => ({
    formResource: {}
  }),
  mixins: [QuotationMixin],
  components: {
    QuotationResourceForm
  },
  created() {
    this.formResource = { ...this.form };
    this.formResource.value =
      this.previous == "quotation step select resource"
        ? _.cloneDeep(this.readonlyForm.resource.valor) * 100
        : this.formResource.value;
  },
  computed: {
    nextQuotationStep() {
      return {
        name: "quotation step deadline",
        step: 4
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step select resource",
        step: 3
      };
    }
  },
  methods: {
    submit(form) {
      this.$emit(
        "updateStep",
        this.payloadQuotation(form, this.nextQuotationStep)
      );
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formResource, this.previousQuotationStep)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    firstForm: {
      type: Object
    },
    previous: {
      type: String
    }
  }
};
</script>
